<template>
  <SfInputExtended
    v-bind="$props"
    :model-value="data"
    @update:modelValue="handleUpdate"
  />
</template>
<script setup lang="ts">
import { ref } from 'vue'

import { SfInputExtended } from '@app/shared/vue/components/sf-input'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfInputConnected',
})

interface Props {
  componentType?: 'input' | 'textarea'
  disabled?: boolean
  errorText?: string | string[]
  helperText?: string
  label?: string
  limit?: number
  limitTranslation?: string
  modelValue?: string
  noClip?: boolean
  placeholder?: string
  small?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  componentType: 'input',
  errorText: () => [],
  helperText: '',
  label: '',
  limit: 0,
  limitTranslation: '',
  placeholder: '',
  modelValue: '',
})

const data = ref(props.modelValue)

function handleUpdate(value: string | undefined) {
  if (value) {
    data.value = value
  }
}
</script>
